import React from 'react';
import { Check } from "lucide-react";

export default function Stepper({ steps, currentStep }) {
    return (
        <div className="mb-8 w-full">
            <div className="flex items-start w-full">
                {steps.map((step, index) => {
                    const Icon = step.icon;
                    const isActive = currentStep === step.number;
                    const isCompleted = currentStep > step.number;

                    return (
                        <React.Fragment key={step.number}>
                            <div className="flex flex-col items-center relative z-10">
                                <div
                                    className={`
                                        relative w-14 h-14 rounded-full flex items-center justify-center
                                        transition-all duration-300 mb-3 shadow-md
                                        ${isActive ? "bg-gradient-to-br from-blue-500 to-blue-600 text-white scale-110 shadow-lg ring-4 ring-blue-100" : ""}
                                        ${isCompleted ? "bg-gradient-to-br from-green-500 to-emerald-600 text-white shadow-lg" : ""}
                                        ${!isActive && !isCompleted ? "bg-white text-gray-400 border-2 border-gray-300" : ""}
                                    `}
                                >
                                    {isCompleted ? (
                                        <div className="relative">
                                            <Check className="w-7 h-7 animate-in zoom-in duration-300" strokeWidth={3} />
                                        </div>
                                    ) : (
                                        <Icon className="w-7 h-7" strokeWidth={isActive ? 2.5 : 2} />
                                    )}

                                    {!isCompleted && (
                                        <div className={`
                                            absolute -top-1 -right-1 w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold
                                            ${isActive ? "bg-white text-blue-600" : "bg-gray-200 text-gray-600"}
                                        `}>
                                            {step.number}
                                        </div>
                                    )}
                                </div>
                                <div className="text-center w-32 md:w-40">
                                    <p className={`
                                        text-sm font-bold transition-colors whitespace-nowrap
                                        ${isActive ? "text-blue-600" : ""}
                                        ${isCompleted ? "text-green-600" : ""}
                                        ${!isActive && !isCompleted ? "text-gray-500" : ""}
                                    `}>
                                        {step.title}
                                    </p>
                                    <p className="text-xs text-gray-500 mt-0.5 line-clamp-2 md:line-clamp-none">{step.description}</p>
                                </div>
                            </div>

                            {index < steps.length - 1 && (
                                <div className="flex-1 h-1 bg-gray-200 rounded-full mx-2 mt-7 relative">
                                    <div
                                        className={`
                                            absolute inset-0 h-full rounded-full transition-all duration-500
                                            ${isCompleted ? "bg-gradient-to-r from-green-500 to-emerald-600 w-full" : "w-0"}
                                        `}
                                    />
                                </div>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
}
